var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-2"},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.getImage,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }